import { ChevronDownIcon } from './ChevronDownIcon';

/**
 * author: Google
 * id 84FE90C1-076D-4EA1-B56F-4C2582A39AC3
 * name chevron-down
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chevron-down.svg
 * tags
 * - Arrow 
 */
export const KeyboardArrowDownIcon = ChevronDownIcon;
export default KeyboardArrowDownIcon